// Forged Athletics "A" monogram — clean geometric reconstruction so we don't
// have to embed the reference logo-grid photo.
export default function Logo({ className = "", size = 40, withText = false, stacked = false }) {
  return (
    <div className={`inline-flex items-center gap-3 ${stacked ? "flex-col gap-1" : ""} ${className}`}>
      <svg
        viewBox="0 0 60 60"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Forged Athletics"
      >
        {/* Outer A wedge */}
        <path d="M30 3 L57 57 L43 57 L38 46 L22 46 L17 57 L3 57 Z" fill="currentColor" />
        {/* Inner negative A */}
        <path d="M26 38 H34 L30 26 Z" fill="#050505" />
        {/* Sharp accent slash (mimics the cut in the reference monogram) */}
        <path d="M30 3 L34 11 L30 19 L26 11 Z" fill="#050505" />
      </svg>
      {withText && (
        <div className={stacked ? "text-center" : ""}>
          <div className="font-heading text-lg leading-none tracking-widest">FORGED</div>
          <div className="font-sub text-[10px] tracking-[0.4em] text-white/50 mt-0.5">ATHLETICS</div>
        </div>
      )}
    </div>
  );
}
